const ErrorFallBack = () => {
  return (
    <div className="error-fallback-container" style={{ height: "100vh" }}>
      <h2>Something went wrong.... Try Reloading the page</h2>
    </div>
  );
};
export default ErrorFallBack;
